import { Component, OnInit } from '@angular/core';
import { catchError, map } from 'rxjs';
import { AddressType } from 'src/app/accounts-v2/models/fields/addressType.model';
import { SharedDataService } from 'src/app/modules/shared/stores/sharedDataStore/sharedData.service';
import { ConfigurationService } from '../../configurationService';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';
import { CrmSettingModel } from '../../models/organization-settings.model';

@Component({
    selector: 'app-f-setting',
    templateUrl: './setting.component.html',
    styleUrls: ['./setting.component.scss']
})
export class FSettingComponent implements OnInit {

    index = 0;
    configMenuOrdersItems = [];

    expandedRows: {} = {};
    selectedSettings: CrmSettingModel | null = null;
    crmSettingFieldsList: CrmSettingModel[] = [];
    addressSettings: CrmSettingModel = {
        id: 1,
        name: "Default Address Type Of Account & Lead For Territory",
        description: "Default Address Type Of Account & Lead For Territory",
        enabled: true,
        actionDisabled: true,
        value: null,
        displayValue: null,
        moduleId: 0,
        code: 'defaultAddress'
    }

    //Address Settings
    addressTypes: AddressType[] = [];
    selectedAddresId: number;
    selectedAddress: any;
    displayAddressEdit: boolean = false;

    //Visit Settings
    occurrenceTypes = [
        { id: 1, name: 'Years' },
        { id: 2, name: 'Months' },
        { id: 3, name: 'Days' },
        { id: 4, name: 'Hours' },
        { id: 5, name: 'Minutes' },
        { id: 6, name: 'Seconds' }
    ];
    visitRangeValue: number = 0;
    visitRangeUnitId: number = 3;
    displayVisitEdit: boolean = false;

    //Geo Matched Radius
    visitRadiusUnits = [
        { id: 1, name: 'Miles' },
        { id: 2, name: 'Kilometers' }
    ];

    visitRadiusValue: number = 0.2;
    visitRadiusUnitId: number = 1;
    displayVisitRadiusEdit: boolean = false;

    constructor(
        private sharedDataService: SharedDataService,
        private configurationService: ConfigurationService,
        private app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService
    ) { }

    ngOnInit(): void {
        this.configMenuOrdersItems = [
            // {
            //     label: 'Setting',
            //     icon: "pi pi-plus",
            //     command: () => { },
            // },
        ];
        this.getSettingsData();
        this.loadAddressTypes();
        this.sharedDataService.dispatchGettingAddressTypes();
    }

    getSettingsData() {
        this.configurationService.getCrmSettingFieldsList().subscribe({
            next: (response: CrmSettingModel[]) => {
                this.crmSettingFieldsList = response || [];
                this.crmSettingFieldsList = this.crmSettingFieldsList.filter(c => ['fieldVisitTimeRange','VisitGeoMatchingRange'].includes(c.code));
                this.crmSettingFieldsList = [...[this.addressSettings], ...this.crmSettingFieldsList];
                if (this.crmSettingFieldsList?.length) {
                    this.crmSettingFieldsList.map(setting => {
                        setting.displayValue = setting?.value;
                        if (setting.code == 'fieldVisitTimeRange' && setting?.value) {
                            const value = JSON.parse(setting.value);
                            const name = this.occurrenceTypes.find(o => o.id == value?.unit)?.name;
                            setting.displayValue = `${value.value} ${name}`;
                        }else if(setting.code == 'VisitGeoMatchingRange' && setting?.value){
                            const value = JSON.parse(setting.value);
                            const name = this.visitRadiusUnits.find(o => o.id == value?.unit)?.name;
                            setting.displayValue = `${value.value} ${name}`;
                            setting.actionDisabled = true;
                        }
                    })
                }
            },
            error: (error) => { }
        });
    }

    editCsetting(data) {
        this.selectedSettings = data;
        switch (data.code) {
            case 'defaultAddress':
                this.selectedAddresId = this.selectedAddress?.id||null;
                this.displayAddressEdit = true;
                break;
            case 'fieldVisitTimeRange':
                const value = data?.value ? JSON.parse(data.value) : null;
                this.visitRangeValue = value?.value||1;
                this.visitRangeUnitId = value?.unit||3;
                this.displayVisitEdit = true;
                break;
            case 'VisitGeoMatchingRange':
                const gValue = data?.value ? JSON.parse(data.value) : null;
                this.visitRadiusValue = gValue?.value||0.2;
                this.visitRadiusUnitId = gValue?.unit||1;
                this.displayVisitRadiusEdit = true;
                break;
        }
    }

    changeCrmSeetings(data) {
        if (['fieldVisitTimeRange'].includes(data?.code) && !data?.value && data.enabled) {
            this.editCsetting(data);
            data.enabled = false;
            return;
        }

        const requestBody = {
            code: data?.code,
            enabled: data?.enabled,
            moduleId: data?.moduleId,
            value: data?.value
        }

        this.configurationService.updateCrmSetting(requestBody).subscribe({
            next: (response) => {
                this.displayVisitEdit = false;
                this.displayVisitRadiusEdit = false;
                this.getSettingsData();
            },
            error: (error) => {
            }
        });
    }

    getIndex(event) {
        this.index = event.index;
    }

    loadAddressTypes(): void {
        this.sharedDataService
            .loadAddressTypes()
            .pipe(
                map((addressTypes) => {
                    this.addressTypes = addressTypes?.filter((el) => el.isActive) || [];
                    this.getSelectedAddress();
                }),
                catchError(() => [])
            )
            .subscribe();

    }

    onSaveAddress() {
        const updatedAddress = {
            organizationId: this.app.user.organizationId,
            statusId: 1,
            choiceofaddressId: this.selectedAddresId
        }

        this.configurationService.fSettingAddress(updatedAddress).subscribe({
            next: (response: any) => {
                this.selectedAddress = this.addressTypes.find(data => data?.id === this.selectedAddresId);
                this.displayAddressEdit = false;
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Address Type Updated Successfully",
                });
            },
            error: (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: error?.error?.Message ? error?.error?.Message : `Failed`,
                });

            },
        });
    }

    getSelectedAddress() {
        this.configurationService.getFSettingAddress().subscribe({
            next: (response: any) => {
                this.appMainService.isHideSpinner('updateRootTerritory');
                const data = response;
                this.selectedAddresId = data?.choiceofaddressId;
                if (this.selectedAddresId) {
                    this.selectedAddress = this.addressTypes.find(data => data?.id === this.selectedAddresId);
                }

            },
            error: (error) => {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: error?.error?.Message ? error?.error?.Message : `Failed`,
                });
                this.appMainService.isHideSpinner('updateRootTerritory');
            },
        });
    }

    saveVisitSetting(){
        const settingData = {
            ...this.selectedSettings,
            enabled: true,
            value: JSON.stringify({value: this.visitRangeValue, unit: this.visitRangeUnitId})
        }

        this.changeCrmSeetings(settingData);
    }

    saveVisitRadiusSetting(){
        const settingData = {
            ...this.selectedSettings,
            enabled: true,
            value: JSON.stringify({value: this.visitRadiusValue, unit: this.visitRadiusUnitId})
        }

        this.changeCrmSeetings(settingData);
    }
}
